<template>
  <div class="balance mt-5">
    <div class="col-6 balance-card mb-3" :class="`balance__color-${(idx)%3}`" v-for="(balance,idx) in balances">
      <div v-if="balance.is_money" >
        <div class="d-flex justify-content-center">
          <p class="currency">грн</p>
          <div  class="d-flex">
            <p class="amount">{{balance.amount}}</p>
            <p class="cent" v-if="balance.cent">.{{ balance.cent }}</p>
          </div>
        </div>
        <p class="name">{{balance.name}}</p>
      </div>
      <div v-else>
        <div class="d-flex justify-content-center flex-row">
          <p class="d-flex flex-row">
            <span class="d-block mr-1 count">{{balance.value}}</span>
            <span class="d-block letter-spacing" v-html="$t('account.available_records')"></span>
          </p>

        </div>
        <p class="name">{{balance.name}}</p>

      </div>

    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Balance",
  data() {
    return {
      balances: []
    }
  },
  computed: {
    ...mapGetters([
      'patient'
    ])
  },
  methods: {},
  mounted() {
    if(this.patient && this.patient.balances.length === 0){
      this.$router.push({name:'profile.info.info-change'})
    }
    if (this.patient) {
      this.balances = this.patient.balances.map((item) => {
        let result = {
          name: item.type_name,
          is_money: item.is_money,
        }
        if (item.is_money) {
          let splitValue = String(item.value).split('.')
          result['amount'] = splitValue[0]
          if (splitValue[1]) {
            result['cent'] = `${splitValue[1]}0`
          }

        } else {
          result['value'] = item.value
        }
        return result
      })
    }
  }

}
</script>

<style scoped>

</style>